export const MAX_PAGES_TO_DISPLAY = 4;

export function paginate(page: number, totalPages: number) {
  const pages: Array<string | number> = [1];

  if (page === 1 && totalPages === 1) {
    return { current: page, pages };
  }

  if (page > MAX_PAGES_TO_DISPLAY) {
    pages.push('...');
  }

  const range = 2;
  const start = page - range;
  const end = page + range;

  for (let i = start > 2 ? start : 2; i <= Math.min(totalPages, end); i++) {
    pages.push(i);
  }

  if (end + 1 < totalPages) {
    pages.push('...');
  }

  if (end < totalPages) {
    pages.push(totalPages);
  }

  return { current: page, pages };
}
